import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5058`;

const instance = axios.create({
  baseURL: API_URL
});

// Configurar interceptor para incluir el token si existe
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
